import React from "react";
import Button from "views/components/button/Button";
import userTracker from "lib/userTracker";

import style from "./style.module.css";

export const MOBILE_ADD_PAGE_PANEL_ID = "MOBILE-ADD-PAGE-PANEL";

const AddNewPageButton = ({
  canAddNewPage,
  isMobile,
  onClick,
  pageHeight,
  pageWidth
}) => {
  if (!canAddNewPage) {
    return null;
  }

  const onAddNewPageClick = () => {
    userTracker.track({
      event: userTracker.events.addPage,
      properties: {
        source: isMobile ? "mobile_add_page_panel" : "add_new_page_button"
      }
    });

    onClick();
  };

  if (isMobile) {
    return (
      <div
        id={MOBILE_ADD_PAGE_PANEL_ID}
        className={style.mobileAddPagePanel}
        data-testid="mobile-add-page-panel"
        style={{ height: pageHeight, width: pageWidth }}
      >
        <div className={style.mobileAddPagePlaceholder}>
          <Button theme="grayBorderOnly" onClick={onAddNewPageClick}>
            Add New Page
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={style.canvasBackgroundButton}>
      <Button isWide theme="canvas" onClick={onAddNewPageClick}>
        Add new page
      </Button>
    </div>
  );
};

export default AddNewPageButton;
